(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function store(get, key, val) {
    try { return get ? localStorage.getItem(key) : localStorage.setItem(key, val); } catch (e) { return null; }
  }
  function openDialog(el, focusSel) {
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector(focusSel);
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDialog(el) {
    el.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* Zoek jouw parfum: prijsvergelijker */
  var finder = document.getElementById('finder');
  if (finder) {
    var data = [];
    try { data = JSON.parse(document.getElementById('finder-data').textContent); } catch (e) {}
    var input = finder.querySelector('[data-finder-input]');
    var results = finder.querySelector('[data-finder-results]');
    var steps = finder.querySelector('[data-finder-steps]');
    var intro = finder.querySelector('[data-finder-intro]');
    var sortBar = finder.querySelector('[data-finder-sort]');
    var clearBtn = finder.querySelector('[data-finder-clear]');
    var sortDir = 'asc';
    function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
    function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    data.forEach(function (d) { d.s = norm([d.t, d.b, d.n, d.k].join(' ')); });

    function addToCart(btn, id) {
      btn.disabled = true; btn.textContent = 'Toevoegen…';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; if (window.DariCart) { closeDialog(finder); btn.disabled = false; btn.textContent = 'Toegevoegd'; window.DariCart.refresh().then(window.DariCart.open); } else { window.location.href = root + 'cart'; } })
        .catch(function () { btn.disabled = false; btn.textContent = 'Probeer opnieuw'; });
    }

    function card(d) {
      var c = el('div', 'finder__card');
      if (d.i) { var img = el('img'); img.src = d.i; img.alt = ''; img.loading = 'lazy'; c.appendChild(img); }
      c.appendChild(el('div', 'finder__card-t', d.t));
      c.appendChild(el('div', 'finder__card-p', euro(d.p)));
      if (d.o && d.o > d.p) c.appendChild(el('span', 'finder__save', 'Bespaar ' + Math.round((1 - d.p / d.o) * 100) + '%'));
      var btn = el('button', 'finder__add', d.a ? 'In winkelwagen' : 'Uitverkocht');
      btn.type = 'button'; btn.disabled = !d.a;
      btn.addEventListener('click', function () { addToCart(btn, d.v); });
      c.appendChild(btn);
      var a = el('a', 'finder__view', 'Bekijk product'); a.href = d.u; c.appendChild(a);
      return c;
    }

    function render() {
      var q = norm(input.value.trim());
      clearBtn.hidden = !q;
      results.textContent = '';
      if (q.length < 2) { steps.hidden = false; intro.hidden = false; sortBar.hidden = true; return; }
      steps.hidden = true; intro.hidden = true;
      var words = q.split(/\s+/);
      var hits = data.filter(function (d) { return words.every(function (w) { return d.s.indexOf(w) > -1; }); });
      sortBar.hidden = !hits.length;
      if (!hits.length) {
        var none = el('div', 'finder__none');
        none.appendChild(el('p', null, 'Deze geur hebben we (nog) niet. Wij maken hem graag speciaal voor jou.'));
        var ex = el('a', 'btn', 'Vraag hem aan via Dar Exclusive'); ex.href = root + 'pages/dar-exclusive';
        none.appendChild(ex); results.appendChild(none); return;
      }
      hits.sort(function (x, y) { return sortDir === 'asc' ? x.p - y.p : y.p - x.p; });
      var groups = {}; var order = [];
      hits.forEach(function (d) {
        var key = (d.b + '|' + d.n).toLowerCase();
        if (!groups[key]) { groups[key] = []; order.push(key); }
        groups[key].push(d);
      });
      order.forEach(function (key) {
        var list = groups[key]; var f = list[0];
        var g = el('div', 'finder__group');
        if (f.b || f.n) {
          var o = el('div', 'finder__orig');
          o.appendChild(el('div', 'finder__orig-k', 'Het origineel'));
          if (f.b) o.appendChild(el('div', 'finder__orig-b', f.b));
          if (f.n) o.appendChild(el('div', 'finder__orig-n', f.n));
          if (f.np) o.appendChild(el('div', 'finder__orig-notes', f.np));
          if (f.o) { var op = el('div', 'finder__orig-price'); op.appendChild(document.createTextNode('Origineel: ')); op.appendChild(el('s', null, euro(f.o))); o.appendChild(op); }
          g.appendChild(o);
        }
        var grid = el('div', 'finder__grid');
        list.forEach(function (d) { grid.appendChild(card(d)); });
        g.appendChild(grid);
        results.appendChild(g);
      });
    }

    document.querySelectorAll('[data-finder-open]').forEach(function (b) {
      b.addEventListener('click', function () { openDialog(finder, '[data-finder-input]'); });
    });
    finder.querySelectorAll('[data-finder-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeDialog(finder); });
    });
    input.addEventListener('input', render);
    clearBtn.addEventListener('click', function () { input.value = ''; render(); input.focus(); });
    finder.querySelectorAll('[data-sort]').forEach(function (b) {
      b.addEventListener('click', function () {
        sortDir = b.dataset.sort;
        finder.querySelectorAll('[data-sort]').forEach(function (o) { o.classList.toggle('is-active', o === b); });
        render();
      });
    });
  }

  /* Kortingspopup: bij weggaan (desktop) of na een tijdje (mobiel), max. 1x per 7 dagen */
  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var KEY = 'dari_popup_seen';
    var last = parseInt(store(true, KEY) || '0', 10);
    var allowed = !last || (Date.now() - last) > 7 * 864e5;
    var shown = false;
    function show() {
      if (shown || !allowed) return;
      shown = true;
      store(false, KEY, String(Date.now()));
      openDialog(popup, 'input[type=email]');
    }
    popup.querySelectorAll('[data-popup-close]').forEach(function (b) {
      b.addEventListener('click', function () { closeDialog(popup); });
    });
    if (allowed) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) show();
      });
      var delay = parseInt(popup.dataset.delay || '20', 10) * 1000;
      setTimeout(show, delay);
    }
    var form = popup.querySelector('[data-popup-form]');
    var err = popup.querySelector('[data-popup-error]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var email = form.querySelector('input[type=email]');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
          e.preventDefault(); err.hidden = false; return;
        }
        e.preventDefault();
        fetch(form.action, { method: 'POST', body: new FormData(form) })
          .then(function () {
            popup.querySelector('[data-popup-form-wrap]').hidden = true;
            popup.querySelector('[data-popup-success]').hidden = false;
          })
          .catch(function () { form.submit(); });
      });
      form.querySelector('input[type=email]').addEventListener('input', function () { err.hidden = true; });
    }
    var copy = popup.querySelector('[data-popup-copy]');
    if (copy) copy.addEventListener('click', function () {
      try { navigator.clipboard.writeText(copy.dataset.code); copy.textContent = 'Gekopieerd'; } catch (e) {}
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    [finder, popup].forEach(function (d) { if (d && !d.hidden) closeDialog(d); });
  });

  /* Levertimer: aftellen tot de echte besteldeadline (werkdagen) */
  document.querySelectorAll('[data-ship-timer]').forEach(function (el) {
    var cutoff = parseInt(el.dataset.cutoff || '16', 10);
    var out = el.querySelector('[data-ship-text]');
    function nowNL() {
      var s = new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' });
      return new Date(s);
    }
    function tick() {
      var n = nowNL();
      var day = n.getDay();
      var deadline = new Date(n); deadline.setHours(cutoff, 0, 0, 0);
      if (day >= 1 && day <= 5 && n < deadline) {
        var ms = deadline - n;
        var h = Math.floor(ms / 36e5), m = Math.floor((ms % 36e5) / 6e4);
        var when = day === 5 ? 'maandag' : 'morgen';
        out.innerHTML = 'Bestel binnen <strong>' + (h ? h + 'u ' : '') + m + 'm</strong> en het is ' + when + ' in huis';
      } else {
        out.textContent = 'Voor ' + cutoff + ':00 besteld op een werkdag, de volgende dag in huis';
      }
    }
    tick(); setInterval(tick, 30000);
  });

  /* Bundel: aantal in het formulier zetten */
  document.querySelectorAll('[data-bundle] input[type=radio]').forEach(function (r) {
    r.addEventListener('change', function () {
      var qty = document.getElementById('quantity');
      if (qty) qty.value = r.value;
    });
  });
})();
